import styled, { css } from 'styled-components';
import { themeMap } from '../../utils/colorThemes.js';
import mq from '../../utils/mediaQueries.js';

// @ts-nocheck
var mainWidth = 215;
var mainHeight = 49;
var mainWidthMobile = 160;
var mainHeightMobile = 39;
var mainWidthSmall = 170;
var mainHeightSmall = 39;
var mainWidthSmallMobile = 140;
var mainHeightSmallmobile = 32;
var Wrapper = styled.div.withConfig({
  displayName: "TouchPadsstyle__Wrapper",
  componentId: "sc-1nspgki-0"
})(["display:inline-block;position:relative;"]);
var TocuhPad = styled.div.withConfig({
  displayName: "TouchPadsstyle__TocuhPad",
  componentId: "sc-1nspgki-1"
})(["width:", "px;height:77px;position:relative;overflow:hidden;transform:translate(0%,0%) rotate(-5deg);", " ", ""], mainWidthMobile + 10, function (props) {
  return props.$isSmall && css(["width:", "px;height:64px;position:absolute;right:-63px;bottom:-31px;"], mainWidthSmallMobile + 10);
}, mq.s(css(["width:", "px;height:101px;", ""], mainWidth + 10, function (props) {
  return props.$isSmall && css(["width:", "px;height:77px;right:-75px;bottom:-34px;position:absolute;"], mainWidthSmall + 10);
})));
var TocuhPadInner = styled.div.withConfig({
  displayName: "TouchPadsstyle__TocuhPadInner",
  componentId: "sc-1nspgki-2"
})(["display:flex;justify-content:center;align-items:center;width:", "px;height:", "px;position:absolute;border-radius:10px;top:19px;left:5px;", " ", " ", " &::before{content:\"\";position:absolute;top:-20px;left:0;width:0;height:0;border-left:", "px solid transparent;border-right:", "px solid transparent;border-radius:15px;", " ", " ", "}&::after{content:\"\";position:absolute;bottom:-20px;left:0;width:0;height:0;border-left:", "px solid transparent;border-right:", "px solid transparent;border-radius:15px;", " ", " ", "}"], mainWidthMobile, mainHeightMobile, function (props) {
  return props.$isSmall && css(["width:", "px;height:", "px;position:absolute;top:16px;"], mainWidthSmallMobile, mainHeightSmallmobile);
}, function (props) {
  return props.$colorTheme && css(["background:", ";color:", ";"], themeMap[props.$colorTheme].background, themeMap[props.$colorTheme].text);
}, mq.s(css(["width:", "px;height:", "px;top:26px;", ""], mainWidth, mainHeight, function (props) {
  return props.$isSmall && css(["width:", "px;height:", "px;top:19px;"], mainWidthSmall, mainHeightSmall);
})), mainWidthMobile / 2, mainWidthMobile / 2, function (props) {
  return props.$colorTheme && css(["border-bottom:22px solid ", ";"], themeMap[props.$colorTheme].background);
}, function (props) {
  return props.$isSmall && css(["top:-17px;border-left:", "px solid transparent;border-right:", "px solid transparent;border-bottom:19px solid ", ";"], mainWidthSmallMobile / 2, mainWidthSmallMobile / 2, themeMap[props.$colorTheme].background);
}, mq.s(css(["top:-27px;border-left:", "px solid transparent;border-right:", "px solid transparent;", " ", ""], mainWidth / 2, mainWidth / 2, function (props) {
  return props.$colorTheme && css(["border-bottom:29px solid ", ";"], themeMap[props.$colorTheme].background);
}, function (props) {
  return props.$isSmall && css(["top:-20px;border-left:", "px solid transparent;border-right:", "px solid transparent;border-bottom:22px solid ", ";"], mainWidthSmall / 2, mainWidthSmall / 2, themeMap[props.$colorTheme].background);
})), mainWidthMobile / 2, mainWidthMobile / 2, function (props) {
  return props.$colorTheme && css(["border-top:22px solid ", ";"], themeMap[props.$colorTheme].background);
}, function (props) {
  return props.$isSmall && css(["bottom:-17px;border-left:", "px solid transparent;border-right:", "px solid transparent;border-top:19px solid ", ";"], mainWidthSmallMobile / 2, mainWidthSmallMobile / 2, themeMap[props.$colorTheme].background);
}, mq.s(css(["bottom:-27px;border-left:", "px solid transparent;border-right:", "px solid transparent;", " ", ""], mainWidth / 2, mainWidth / 2, function (props) {
  return props.$colorTheme && css(["border-top:29px solid ", ";"], themeMap[props.$colorTheme].background);
}, function (props) {
  return props.$isSmall && css(["bottom:-20px;border-left:", "px solid transparent;border-right:", "px solid transparent;border-top:22px solid ", ";"], mainWidthSmall / 2, mainWidthSmall / 2, themeMap[props.$colorTheme].background);
})));
var TocuhPadText = styled.div.withConfig({
  displayName: "TouchPadsstyle__TocuhPadText",
  componentId: "sc-1nspgki-3"
})(["font-family:var(--font-family-headline);font-weight:700;font-size:17px;font-style:italic;max-width:110px;text-align:center;transform:translate(0%,0%) rotate(-1deg);z-index:1;", " ", ""], function (props) {
  return props.$isSmall && css(["font-size:14px;max-width:90px;"]);
}, mq.s(css(["font-size:20px;max-width:140px;", ""], function (props) {
  return props.$isSmall && css(["font-size:17px;max-width:120px;"]);
})));

export { TocuhPad, TocuhPadInner, TocuhPadText, Wrapper };
//# sourceMappingURL=TouchPads.style.js.map
